import _ from 'lodash'
import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Device } from '../../types'
import * as actions from './actions'

export type State = { [id: string]: Device }

const initialState: State = {}

// Firebase スナップショットは常に「最新の全体」。info は置換し (deep-merge しない)、
// lastLogs はセッション単位でマージしつつ各ログは置換する。更新対象のデバイスだけ
// 新オブジェクトにし、他デバイスは参照を維持する。
//
// 以前は `_.merge({}, state, …)` で
//  (1) 毎更新ごとにストア全体をディープクローン → 1 台のログで全カードが再レンダー、
//  (2) deep-merge がソースに無いキーを消さない → クリアされた threasholds.levelD や
//      ch 数減少後の古い sensor が残り、淡水ラベル誤表示・22ch 誤表示の原因になっていた。
const mergeDevice = (prev: Device | undefined, obj: Partial<Device>): Device =>
  ({
    ...prev,
    ...obj,
    lastLogs: { ...(prev && prev.lastLogs), ...obj.lastLogs },
  } as Device)

export default reducerWithInitialState<State>(initialState)
  .case(actions.receiveDevice, (state, obj) => {
    if (!obj.id) {
      return state
    }
    return { ...state, [obj.id]: mergeDevice(state[obj.id], obj) }
  })
  .case(actions.receiveDeviceToken, (state, { id, token }) => {
    const prev = state[id]

    return {
      ...state,
      [id]: { ...prev, info: { ...(prev && prev.info), token } } as Device,
    }
  })
  .case(actions.updateDevice, (state, obj) => {
    if (!obj.id) {
      return state
    }
    return { ...state, [obj.id]: mergeDevice(state[obj.id], obj) }
  })
  .case(actions.removeDevice, (state, { id }) => {
    return _.omit(state, [id])
  })
  .case(actions.cleanDevice, () => initialState)
